import { createClient } from '@supabase/supabase-js';

// Tu URL correcta del proyecto de cafereriaapp
const supabaseUrl = 'https://knpjowfxuyauhawvxsxn.supabase.co';

// Tu clave anónima (pública) correcta
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtucGpvd2Z4dXlhdWhhd3Z4c3huIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3MjU5MTksImV4cCI6MjA2NjMwMTkxOX0.7bisqy1g1uhx8IyBLt_PVOCPAEQcAE8L8qcSTW6LoJs';

// Se crea y exporta el cliente de Supabase para usarlo en toda la aplicación
export const supabase = createClient(supabaseUrl, supabaseKey);

